import type { Category } from './types';

export const categories: Category[] = [
  {
    slug: 'discount',
    name: '折扣优惠',
    description: '汇集各大电商平台、线下商超的最新折扣信息，涵盖数码家电、服饰美妆、日用百货等多个品类。',
    icon: 'ri-coupon-2-line',
    articleCount: 48,
    imageSeq: 'cat-discount',
  },
  {
    slug: 'membership',
    name: '会员权益',
    description: '全面整理视频平台、音乐服务、购物会员等各类会员权益，帮你选择最适合的会员方案。',
    icon: 'ri-vip-crown-line',
    articleCount: 36,
    imageSeq: 'cat-membership',
  },
  {
    slug: 'subsidy',
    name: '生活补贴',
    description: '实时更新各地政府发放的消费券、购房补贴、人才补贴、新能源汽车补贴等惠民政策。',
    icon: 'ri-hand-heart-line',
    articleCount: 52,
    imageSeq: 'cat-subsidy',
  },
  {
    slug: 'workplace',
    name: '职场福利',
    description: '分享各大企业员工福利方案、五险一金优化攻略、年终奖税务筹划、股权激励解读等内容。',
    icon: 'ri-briefcase-line',
    articleCount: 41,
    imageSeq: 'cat-workplace',
  },
  {
    slug: 'travel',
    name: '出行旅游',
    description: '提供航班优惠、酒店折扣、景点门票减免、旅游补贴政策等出行相关的福利资讯汇总。',
    icon: 'ri-flight-takeoff-line',
    articleCount: 33,
    imageSeq: 'cat-travel',
  },
  {
    slug: 'education',
    name: '教育学习',
    description: '整合在线课程优惠、职业资格补贴、学历提升补助、语言学习资源等教育类福利信息。',
    icon: 'ri-book-open-line',
    articleCount: 29,
    imageSeq: 'cat-education',
  },
];